/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RisksRouteImport } from './routes/_risks'
import { Route as ClaimsRouteImport } from './routes/_claims'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RisksRisksIndexRouteImport } from './routes/_risks/risks/index'
import { Route as ClaimsClaimsIndexRouteImport } from './routes/_claims/claims/index'
import { Route as AdminAdminUserRouteImport } from './routes/_admin/admin/user'
import { Route as RisksRiskRiskIdRiskRouteImport } from './routes/_risks/risk.$riskId/_risk'
import { Route as ClaimsClaimClaimIdClaimRouteImport } from './routes/_claims/claim.$claimId/_claim'
import { Route as RisksRiskRiskIdRiskIndexRouteImport } from './routes/_risks/risk.$riskId/_risk/index'
import { Route as ClaimsClaimClaimIdClaimIndexRouteImport } from './routes/_claims/claim.$claimId/_claim/index'
import { Route as RisksRiskRiskIdRiskReportRouteImport } from './routes/_risks/risk.$riskId/_risk/report'
import { Route as RisksRiskRiskIdRiskDocumentsRouteImport } from './routes/_risks/risk.$riskId/_risk/documents'
import { Route as RisksRiskRiskIdRiskCalculationsRouteImport } from './routes/_risks/risk.$riskId/_risk/calculations'
import { Route as RisksRiskRiskIdRiskActivityRouteImport } from './routes/_risks/risk.$riskId/_risk/activity'
import { Route as ClaimsClaimClaimIdClaimReportRouteImport } from './routes/_claims/claim.$claimId/_claim/report'
import { Route as ClaimsClaimClaimIdClaimDocumentsRouteImport } from './routes/_claims/claim.$claimId/_claim/documents'
import { Route as ClaimsClaimClaimIdClaimCalculationsRouteImport } from './routes/_claims/claim.$claimId/_claim/calculations'
import { Route as ClaimsClaimClaimIdClaimActivityRouteImport } from './routes/_claims/claim.$claimId/_claim/activity'
import { Route as RisksRiskRiskIdRiskDataIndexRouteImport } from './routes/_risks/risk.$riskId/_risk/data/index'
import { Route as ClaimsClaimClaimIdClaimDataIndexRouteImport } from './routes/_claims/claim.$claimId/_claim/data/index'
import { Route as ClaimsClaimClaimIdClaimBusinessIndexRouteImport } from './routes/_claims/claim.$claimId/_claim/business/index'
import { Route as RisksRiskRiskIdRiskCalculationsSummaryRouteImport } from './routes/_risks/risk.$riskId/_risk/calculations/summary'
import { Route as RisksRiskRiskIdRiskCalculationsAnalysisRouteImport } from './routes/_risks/risk.$riskId/_risk/calculations/analysis'
import { Route as RisksRiskRiskIdnoprEditPageRouteImport } from './routes/_risks/risk.$riskId/(nopr)/edit.$page'
import { Route as RisksRiskRiskIdnoprCreatePageRouteImport } from './routes/_risks/risk.$riskId/(nopr)/create.$page'
import { Route as ClaimsClaimClaimIdClaimCalculationsSalesLossRouteImport } from './routes/_claims/claim.$claimId/_claim/calculations/salesLoss'
import { Route as ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRouteImport } from './routes/_claims/claim.$claimId/_claim/calculations/salesAnalysis'
import { Route as ClaimsClaimClaimIdClaimCalculationsLossRouteImport } from './routes/_claims/claim.$claimId/_claim/calculations/loss'
import { Route as ClaimsClaimClaimIdClaimCalculationsExpensesRouteImport } from './routes/_claims/claim.$claimId/_claim/calculations/expenses'
import { Route as ClaimsClaimClaimIdClaimCalculationsCollectibleRouteImport } from './routes/_claims/claim.$claimId/_claim/calculations/collectible'
import { Route as ClaimsClaimClaimIdClaimCalculationsAverageRouteImport } from './routes/_claims/claim.$claimId/_claim/calculations/average'
import { Route as ClaimsClaimClaimIdquestionnaireBusinessPageRouteImport } from './routes/_claims/claim.$claimId/(questionnaire)/business.$page'
import { Route as ClaimsClaimClaimIdfnolEditPageRouteImport } from './routes/_claims/claim.$claimId/(fnol)/edit.$page'
import { Route as ClaimsClaimClaimIdfnolCreatePageRouteImport } from './routes/_claims/claim.$claimId/(fnol)/create.$page'

const RisksRoute = RisksRouteImport.update({
  id: '/_risks',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimsRoute = ClaimsRouteImport.update({
  id: '/_claims',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RisksRisksIndexRoute = RisksRisksIndexRouteImport.update({
  id: '/risks/',
  path: '/risks/',
  getParentRoute: () => RisksRoute,
} as any)
const ClaimsClaimsIndexRoute = ClaimsClaimsIndexRouteImport.update({
  id: '/claims/',
  path: '/claims/',
  getParentRoute: () => ClaimsRoute,
} as any)
const AdminAdminUserRoute = AdminAdminUserRouteImport.update({
  id: '/admin/user',
  path: '/admin/user',
  getParentRoute: () => AdminRoute,
} as any)
const RisksRiskRiskIdRiskRoute = RisksRiskRiskIdRiskRouteImport.update({
  id: '/risk/$riskId/_risk',
  path: '/risk/$riskId',
  getParentRoute: () => RisksRoute,
} as any)
const ClaimsClaimClaimIdClaimRoute = ClaimsClaimClaimIdClaimRouteImport.update({
  id: '/claim/$claimId/_claim',
  path: '/claim/$claimId',
  getParentRoute: () => ClaimsRoute,
} as any)
const RisksRiskRiskIdRiskIndexRoute =
  RisksRiskRiskIdRiskIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RisksRiskRiskIdRiskRoute,
  } as any)
const ClaimsClaimClaimIdClaimIndexRoute =
  ClaimsClaimClaimIdClaimIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClaimsClaimClaimIdClaimRoute,
  } as any)
const RisksRiskRiskIdRiskReportRoute =
  RisksRiskRiskIdRiskReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => RisksRiskRiskIdRiskRoute,
  } as any)
const RisksRiskRiskIdRiskDocumentsRoute =
  RisksRiskRiskIdRiskDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => RisksRiskRiskIdRiskRoute,
  } as any)
const RisksRiskRiskIdRiskCalculationsRoute =
  RisksRiskRiskIdRiskCalculationsRouteImport.update({
    id: '/calculations',
    path: '/calculations',
    getParentRoute: () => RisksRiskRiskIdRiskRoute,
  } as any)
const RisksRiskRiskIdRiskActivityRoute =
  RisksRiskRiskIdRiskActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => RisksRiskRiskIdRiskRoute,
  } as any)
const ClaimsClaimClaimIdClaimReportRoute =
  ClaimsClaimClaimIdClaimReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => ClaimsClaimClaimIdClaimRoute,
  } as any)
const ClaimsClaimClaimIdClaimDocumentsRoute =
  ClaimsClaimClaimIdClaimDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ClaimsClaimClaimIdClaimRoute,
  } as any)
const ClaimsClaimClaimIdClaimCalculationsRoute =
  ClaimsClaimClaimIdClaimCalculationsRouteImport.update({
    id: '/calculations',
    path: '/calculations',
    getParentRoute: () => ClaimsClaimClaimIdClaimRoute,
  } as any)
const ClaimsClaimClaimIdClaimActivityRoute =
  ClaimsClaimClaimIdClaimActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => ClaimsClaimClaimIdClaimRoute,
  } as any)
const RisksRiskRiskIdRiskDataIndexRoute =
  RisksRiskRiskIdRiskDataIndexRouteImport.update({
    id: '/data/',
    path: '/data/',
    getParentRoute: () => RisksRiskRiskIdRiskRoute,
  } as any)
const ClaimsClaimClaimIdClaimDataIndexRoute =
  ClaimsClaimClaimIdClaimDataIndexRouteImport.update({
    id: '/data/',
    path: '/data/',
    getParentRoute: () => ClaimsClaimClaimIdClaimRoute,
  } as any)
const ClaimsClaimClaimIdClaimBusinessIndexRoute =
  ClaimsClaimClaimIdClaimBusinessIndexRouteImport.update({
    id: '/business/',
    path: '/business/',
    getParentRoute: () => ClaimsClaimClaimIdClaimRoute,
  } as any)
const RisksRiskRiskIdRiskCalculationsSummaryRoute =
  RisksRiskRiskIdRiskCalculationsSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => RisksRiskRiskIdRiskCalculationsRoute,
  } as any)
const RisksRiskRiskIdRiskCalculationsAnalysisRoute =
  RisksRiskRiskIdRiskCalculationsAnalysisRouteImport.update({
    id: '/analysis',
    path: '/analysis',
    getParentRoute: () => RisksRiskRiskIdRiskCalculationsRoute,
  } as any)
const RisksRiskRiskIdnoprEditPageRoute =
  RisksRiskRiskIdnoprEditPageRouteImport.update({
    id: '/risk/$riskId/(nopr)/edit/$page',
    path: '/risk/$riskId/edit/$page',
    getParentRoute: () => RisksRoute,
  } as any)
const RisksRiskRiskIdnoprCreatePageRoute =
  RisksRiskRiskIdnoprCreatePageRouteImport.update({
    id: '/risk/$riskId/(nopr)/create/$page',
    path: '/risk/$riskId/create/$page',
    getParentRoute: () => RisksRoute,
  } as any)
const ClaimsClaimClaimIdClaimCalculationsSalesLossRoute =
  ClaimsClaimClaimIdClaimCalculationsSalesLossRouteImport.update({
    id: '/salesLoss',
    path: '/salesLoss',
    getParentRoute: () => ClaimsClaimClaimIdClaimCalculationsRoute,
  } as any)
const ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute =
  ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRouteImport.update({
    id: '/salesAnalysis',
    path: '/salesAnalysis',
    getParentRoute: () => ClaimsClaimClaimIdClaimCalculationsRoute,
  } as any)
const ClaimsClaimClaimIdClaimCalculationsLossRoute =
  ClaimsClaimClaimIdClaimCalculationsLossRouteImport.update({
    id: '/loss',
    path: '/loss',
    getParentRoute: () => ClaimsClaimClaimIdClaimCalculationsRoute,
  } as any)
const ClaimsClaimClaimIdClaimCalculationsExpensesRoute =
  ClaimsClaimClaimIdClaimCalculationsExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => ClaimsClaimClaimIdClaimCalculationsRoute,
  } as any)
const ClaimsClaimClaimIdClaimCalculationsCollectibleRoute =
  ClaimsClaimClaimIdClaimCalculationsCollectibleRouteImport.update({
    id: '/collectible',
    path: '/collectible',
    getParentRoute: () => ClaimsClaimClaimIdClaimCalculationsRoute,
  } as any)
const ClaimsClaimClaimIdClaimCalculationsAverageRoute =
  ClaimsClaimClaimIdClaimCalculationsAverageRouteImport.update({
    id: '/average',
    path: '/average',
    getParentRoute: () => ClaimsClaimClaimIdClaimCalculationsRoute,
  } as any)
const ClaimsClaimClaimIdquestionnaireBusinessPageRoute =
  ClaimsClaimClaimIdquestionnaireBusinessPageRouteImport.update({
    id: '/claim/$claimId/(questionnaire)/business/$page',
    path: '/claim/$claimId/business/$page',
    getParentRoute: () => ClaimsRoute,
  } as any)
const ClaimsClaimClaimIdfnolEditPageRoute =
  ClaimsClaimClaimIdfnolEditPageRouteImport.update({
    id: '/claim/$claimId/(fnol)/edit/$page',
    path: '/claim/$claimId/edit/$page',
    getParentRoute: () => ClaimsRoute,
  } as any)
const ClaimsClaimClaimIdfnolCreatePageRoute =
  ClaimsClaimClaimIdfnolCreatePageRouteImport.update({
    id: '/claim/$claimId/(fnol)/create/$page',
    path: '/claim/$claimId/create/$page',
    getParentRoute: () => ClaimsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin/user': typeof AdminAdminUserRoute
  '/claims/': typeof ClaimsClaimsIndexRoute
  '/risks/': typeof RisksRisksIndexRoute
  '/claim/$claimId': typeof ClaimsClaimClaimIdClaimRouteWithChildren
  '/risk/$riskId': typeof RisksRiskRiskIdRiskRouteWithChildren
  '/claim/$claimId/activity': typeof ClaimsClaimClaimIdClaimActivityRoute
  '/claim/$claimId/calculations': typeof ClaimsClaimClaimIdClaimCalculationsRouteWithChildren
  '/claim/$claimId/documents': typeof ClaimsClaimClaimIdClaimDocumentsRoute
  '/claim/$claimId/report': typeof ClaimsClaimClaimIdClaimReportRoute
  '/risk/$riskId/activity': typeof RisksRiskRiskIdRiskActivityRoute
  '/risk/$riskId/calculations': typeof RisksRiskRiskIdRiskCalculationsRouteWithChildren
  '/risk/$riskId/documents': typeof RisksRiskRiskIdRiskDocumentsRoute
  '/risk/$riskId/report': typeof RisksRiskRiskIdRiskReportRoute
  '/claim/$claimId/': typeof ClaimsClaimClaimIdClaimIndexRoute
  '/risk/$riskId/': typeof RisksRiskRiskIdRiskIndexRoute
  '/claim/$claimId/create/$page': typeof ClaimsClaimClaimIdfnolCreatePageRoute
  '/claim/$claimId/edit/$page': typeof ClaimsClaimClaimIdfnolEditPageRoute
  '/claim/$claimId/business/$page': typeof ClaimsClaimClaimIdquestionnaireBusinessPageRoute
  '/claim/$claimId/calculations/average': typeof ClaimsClaimClaimIdClaimCalculationsAverageRoute
  '/claim/$claimId/calculations/collectible': typeof ClaimsClaimClaimIdClaimCalculationsCollectibleRoute
  '/claim/$claimId/calculations/expenses': typeof ClaimsClaimClaimIdClaimCalculationsExpensesRoute
  '/claim/$claimId/calculations/loss': typeof ClaimsClaimClaimIdClaimCalculationsLossRoute
  '/claim/$claimId/calculations/salesAnalysis': typeof ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute
  '/claim/$claimId/calculations/salesLoss': typeof ClaimsClaimClaimIdClaimCalculationsSalesLossRoute
  '/risk/$riskId/create/$page': typeof RisksRiskRiskIdnoprCreatePageRoute
  '/risk/$riskId/edit/$page': typeof RisksRiskRiskIdnoprEditPageRoute
  '/risk/$riskId/calculations/analysis': typeof RisksRiskRiskIdRiskCalculationsAnalysisRoute
  '/risk/$riskId/calculations/summary': typeof RisksRiskRiskIdRiskCalculationsSummaryRoute
  '/claim/$claimId/business/': typeof ClaimsClaimClaimIdClaimBusinessIndexRoute
  '/claim/$claimId/data/': typeof ClaimsClaimClaimIdClaimDataIndexRoute
  '/risk/$riskId/data/': typeof RisksRiskRiskIdRiskDataIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/user': typeof AdminAdminUserRoute
  '/claims': typeof ClaimsClaimsIndexRoute
  '/risks': typeof RisksRisksIndexRoute
  '/claim/$claimId/activity': typeof ClaimsClaimClaimIdClaimActivityRoute
  '/claim/$claimId/calculations': typeof ClaimsClaimClaimIdClaimCalculationsRouteWithChildren
  '/claim/$claimId/documents': typeof ClaimsClaimClaimIdClaimDocumentsRoute
  '/claim/$claimId/report': typeof ClaimsClaimClaimIdClaimReportRoute
  '/risk/$riskId/activity': typeof RisksRiskRiskIdRiskActivityRoute
  '/risk/$riskId/calculations': typeof RisksRiskRiskIdRiskCalculationsRouteWithChildren
  '/risk/$riskId/documents': typeof RisksRiskRiskIdRiskDocumentsRoute
  '/risk/$riskId/report': typeof RisksRiskRiskIdRiskReportRoute
  '/claim/$claimId': typeof ClaimsClaimClaimIdClaimIndexRoute
  '/risk/$riskId': typeof RisksRiskRiskIdRiskIndexRoute
  '/claim/$claimId/create/$page': typeof ClaimsClaimClaimIdfnolCreatePageRoute
  '/claim/$claimId/edit/$page': typeof ClaimsClaimClaimIdfnolEditPageRoute
  '/claim/$claimId/business/$page': typeof ClaimsClaimClaimIdquestionnaireBusinessPageRoute
  '/claim/$claimId/calculations/average': typeof ClaimsClaimClaimIdClaimCalculationsAverageRoute
  '/claim/$claimId/calculations/collectible': typeof ClaimsClaimClaimIdClaimCalculationsCollectibleRoute
  '/claim/$claimId/calculations/expenses': typeof ClaimsClaimClaimIdClaimCalculationsExpensesRoute
  '/claim/$claimId/calculations/loss': typeof ClaimsClaimClaimIdClaimCalculationsLossRoute
  '/claim/$claimId/calculations/salesAnalysis': typeof ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute
  '/claim/$claimId/calculations/salesLoss': typeof ClaimsClaimClaimIdClaimCalculationsSalesLossRoute
  '/risk/$riskId/create/$page': typeof RisksRiskRiskIdnoprCreatePageRoute
  '/risk/$riskId/edit/$page': typeof RisksRiskRiskIdnoprEditPageRoute
  '/risk/$riskId/calculations/analysis': typeof RisksRiskRiskIdRiskCalculationsAnalysisRoute
  '/risk/$riskId/calculations/summary': typeof RisksRiskRiskIdRiskCalculationsSummaryRoute
  '/claim/$claimId/business': typeof ClaimsClaimClaimIdClaimBusinessIndexRoute
  '/claim/$claimId/data': typeof ClaimsClaimClaimIdClaimDataIndexRoute
  '/risk/$riskId/data': typeof RisksRiskRiskIdRiskDataIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/_claims': typeof ClaimsRouteWithChildren
  '/_risks': typeof RisksRouteWithChildren
  '/_admin/admin/user': typeof AdminAdminUserRoute
  '/_claims/claims/': typeof ClaimsClaimsIndexRoute
  '/_risks/risks/': typeof RisksRisksIndexRoute
  '/_claims/claim/$claimId/_claim': typeof ClaimsClaimClaimIdClaimRouteWithChildren
  '/_risks/risk/$riskId/_risk': typeof RisksRiskRiskIdRiskRouteWithChildren
  '/_claims/claim/$claimId/_claim/activity': typeof ClaimsClaimClaimIdClaimActivityRoute
  '/_claims/claim/$claimId/_claim/calculations': typeof ClaimsClaimClaimIdClaimCalculationsRouteWithChildren
  '/_claims/claim/$claimId/_claim/documents': typeof ClaimsClaimClaimIdClaimDocumentsRoute
  '/_claims/claim/$claimId/_claim/report': typeof ClaimsClaimClaimIdClaimReportRoute
  '/_risks/risk/$riskId/_risk/activity': typeof RisksRiskRiskIdRiskActivityRoute
  '/_risks/risk/$riskId/_risk/calculations': typeof RisksRiskRiskIdRiskCalculationsRouteWithChildren
  '/_risks/risk/$riskId/_risk/documents': typeof RisksRiskRiskIdRiskDocumentsRoute
  '/_risks/risk/$riskId/_risk/report': typeof RisksRiskRiskIdRiskReportRoute
  '/_claims/claim/$claimId/_claim/': typeof ClaimsClaimClaimIdClaimIndexRoute
  '/_risks/risk/$riskId/_risk/': typeof RisksRiskRiskIdRiskIndexRoute
  '/_claims/claim/$claimId/(fnol)/create/$page': typeof ClaimsClaimClaimIdfnolCreatePageRoute
  '/_claims/claim/$claimId/(fnol)/edit/$page': typeof ClaimsClaimClaimIdfnolEditPageRoute
  '/_claims/claim/$claimId/(questionnaire)/business/$page': typeof ClaimsClaimClaimIdquestionnaireBusinessPageRoute
  '/_claims/claim/$claimId/_claim/calculations/average': typeof ClaimsClaimClaimIdClaimCalculationsAverageRoute
  '/_claims/claim/$claimId/_claim/calculations/collectible': typeof ClaimsClaimClaimIdClaimCalculationsCollectibleRoute
  '/_claims/claim/$claimId/_claim/calculations/expenses': typeof ClaimsClaimClaimIdClaimCalculationsExpensesRoute
  '/_claims/claim/$claimId/_claim/calculations/loss': typeof ClaimsClaimClaimIdClaimCalculationsLossRoute
  '/_claims/claim/$claimId/_claim/calculations/salesAnalysis': typeof ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute
  '/_claims/claim/$claimId/_claim/calculations/salesLoss': typeof ClaimsClaimClaimIdClaimCalculationsSalesLossRoute
  '/_risks/risk/$riskId/(nopr)/create/$page': typeof RisksRiskRiskIdnoprCreatePageRoute
  '/_risks/risk/$riskId/(nopr)/edit/$page': typeof RisksRiskRiskIdnoprEditPageRoute
  '/_risks/risk/$riskId/_risk/calculations/analysis': typeof RisksRiskRiskIdRiskCalculationsAnalysisRoute
  '/_risks/risk/$riskId/_risk/calculations/summary': typeof RisksRiskRiskIdRiskCalculationsSummaryRoute
  '/_claims/claim/$claimId/_claim/business/': typeof ClaimsClaimClaimIdClaimBusinessIndexRoute
  '/_claims/claim/$claimId/_claim/data/': typeof ClaimsClaimClaimIdClaimDataIndexRoute
  '/_risks/risk/$riskId/_risk/data/': typeof RisksRiskRiskIdRiskDataIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin/user'
    | '/claims/'
    | '/risks/'
    | '/claim/$claimId'
    | '/risk/$riskId'
    | '/claim/$claimId/activity'
    | '/claim/$claimId/calculations'
    | '/claim/$claimId/documents'
    | '/claim/$claimId/report'
    | '/risk/$riskId/activity'
    | '/risk/$riskId/calculations'
    | '/risk/$riskId/documents'
    | '/risk/$riskId/report'
    | '/claim/$claimId/'
    | '/risk/$riskId/'
    | '/claim/$claimId/create/$page'
    | '/claim/$claimId/edit/$page'
    | '/claim/$claimId/business/$page'
    | '/claim/$claimId/calculations/average'
    | '/claim/$claimId/calculations/collectible'
    | '/claim/$claimId/calculations/expenses'
    | '/claim/$claimId/calculations/loss'
    | '/claim/$claimId/calculations/salesAnalysis'
    | '/claim/$claimId/calculations/salesLoss'
    | '/risk/$riskId/create/$page'
    | '/risk/$riskId/edit/$page'
    | '/risk/$riskId/calculations/analysis'
    | '/risk/$riskId/calculations/summary'
    | '/claim/$claimId/business/'
    | '/claim/$claimId/data/'
    | '/risk/$riskId/data/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/user'
    | '/claims'
    | '/risks'
    | '/claim/$claimId/activity'
    | '/claim/$claimId/calculations'
    | '/claim/$claimId/documents'
    | '/claim/$claimId/report'
    | '/risk/$riskId/activity'
    | '/risk/$riskId/calculations'
    | '/risk/$riskId/documents'
    | '/risk/$riskId/report'
    | '/claim/$claimId'
    | '/risk/$riskId'
    | '/claim/$claimId/create/$page'
    | '/claim/$claimId/edit/$page'
    | '/claim/$claimId/business/$page'
    | '/claim/$claimId/calculations/average'
    | '/claim/$claimId/calculations/collectible'
    | '/claim/$claimId/calculations/expenses'
    | '/claim/$claimId/calculations/loss'
    | '/claim/$claimId/calculations/salesAnalysis'
    | '/claim/$claimId/calculations/salesLoss'
    | '/risk/$riskId/create/$page'
    | '/risk/$riskId/edit/$page'
    | '/risk/$riskId/calculations/analysis'
    | '/risk/$riskId/calculations/summary'
    | '/claim/$claimId/business'
    | '/claim/$claimId/data'
    | '/risk/$riskId/data'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_claims'
    | '/_risks'
    | '/_admin/admin/user'
    | '/_claims/claims/'
    | '/_risks/risks/'
    | '/_claims/claim/$claimId/_claim'
    | '/_risks/risk/$riskId/_risk'
    | '/_claims/claim/$claimId/_claim/activity'
    | '/_claims/claim/$claimId/_claim/calculations'
    | '/_claims/claim/$claimId/_claim/documents'
    | '/_claims/claim/$claimId/_claim/report'
    | '/_risks/risk/$riskId/_risk/activity'
    | '/_risks/risk/$riskId/_risk/calculations'
    | '/_risks/risk/$riskId/_risk/documents'
    | '/_risks/risk/$riskId/_risk/report'
    | '/_claims/claim/$claimId/_claim/'
    | '/_risks/risk/$riskId/_risk/'
    | '/_claims/claim/$claimId/(fnol)/create/$page'
    | '/_claims/claim/$claimId/(fnol)/edit/$page'
    | '/_claims/claim/$claimId/(questionnaire)/business/$page'
    | '/_claims/claim/$claimId/_claim/calculations/average'
    | '/_claims/claim/$claimId/_claim/calculations/collectible'
    | '/_claims/claim/$claimId/_claim/calculations/expenses'
    | '/_claims/claim/$claimId/_claim/calculations/loss'
    | '/_claims/claim/$claimId/_claim/calculations/salesAnalysis'
    | '/_claims/claim/$claimId/_claim/calculations/salesLoss'
    | '/_risks/risk/$riskId/(nopr)/create/$page'
    | '/_risks/risk/$riskId/(nopr)/edit/$page'
    | '/_risks/risk/$riskId/_risk/calculations/analysis'
    | '/_risks/risk/$riskId/_risk/calculations/summary'
    | '/_claims/claim/$claimId/_claim/business/'
    | '/_claims/claim/$claimId/_claim/data/'
    | '/_risks/risk/$riskId/_risk/data/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ClaimsRoute: typeof ClaimsRouteWithChildren
  RisksRoute: typeof RisksRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_risks': {
      id: '/_risks'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof RisksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_claims': {
      id: '/_claims'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ClaimsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_risks/risks/': {
      id: '/_risks/risks/'
      path: '/risks'
      fullPath: '/risks/'
      preLoaderRoute: typeof RisksRisksIndexRouteImport
      parentRoute: typeof RisksRoute
    }
    '/_claims/claims/': {
      id: '/_claims/claims/'
      path: '/claims'
      fullPath: '/claims/'
      preLoaderRoute: typeof ClaimsClaimsIndexRouteImport
      parentRoute: typeof ClaimsRoute
    }
    '/_admin/admin/user': {
      id: '/_admin/admin/user'
      path: '/admin/user'
      fullPath: '/admin/user'
      preLoaderRoute: typeof AdminAdminUserRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_risks/risk/$riskId/_risk': {
      id: '/_risks/risk/$riskId/_risk'
      path: '/risk/$riskId'
      fullPath: '/risk/$riskId'
      preLoaderRoute: typeof RisksRiskRiskIdRiskRouteImport
      parentRoute: typeof RisksRoute
    }
    '/_claims/claim/$claimId/_claim': {
      id: '/_claims/claim/$claimId/_claim'
      path: '/claim/$claimId'
      fullPath: '/claim/$claimId'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimRouteImport
      parentRoute: typeof ClaimsRoute
    }
    '/_risks/risk/$riskId/_risk/': {
      id: '/_risks/risk/$riskId/_risk/'
      path: '/'
      fullPath: '/risk/$riskId/'
      preLoaderRoute: typeof RisksRiskRiskIdRiskIndexRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskRoute
    }
    '/_claims/claim/$claimId/_claim/': {
      id: '/_claims/claim/$claimId/_claim/'
      path: '/'
      fullPath: '/claim/$claimId/'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimIndexRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimRoute
    }
    '/_risks/risk/$riskId/_risk/report': {
      id: '/_risks/risk/$riskId/_risk/report'
      path: '/report'
      fullPath: '/risk/$riskId/report'
      preLoaderRoute: typeof RisksRiskRiskIdRiskReportRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskRoute
    }
    '/_risks/risk/$riskId/_risk/documents': {
      id: '/_risks/risk/$riskId/_risk/documents'
      path: '/documents'
      fullPath: '/risk/$riskId/documents'
      preLoaderRoute: typeof RisksRiskRiskIdRiskDocumentsRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskRoute
    }
    '/_risks/risk/$riskId/_risk/calculations': {
      id: '/_risks/risk/$riskId/_risk/calculations'
      path: '/calculations'
      fullPath: '/risk/$riskId/calculations'
      preLoaderRoute: typeof RisksRiskRiskIdRiskCalculationsRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskRoute
    }
    '/_risks/risk/$riskId/_risk/activity': {
      id: '/_risks/risk/$riskId/_risk/activity'
      path: '/activity'
      fullPath: '/risk/$riskId/activity'
      preLoaderRoute: typeof RisksRiskRiskIdRiskActivityRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskRoute
    }
    '/_claims/claim/$claimId/_claim/report': {
      id: '/_claims/claim/$claimId/_claim/report'
      path: '/report'
      fullPath: '/claim/$claimId/report'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimReportRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimRoute
    }
    '/_claims/claim/$claimId/_claim/documents': {
      id: '/_claims/claim/$claimId/_claim/documents'
      path: '/documents'
      fullPath: '/claim/$claimId/documents'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimDocumentsRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimRoute
    }
    '/_claims/claim/$claimId/_claim/calculations': {
      id: '/_claims/claim/$claimId/_claim/calculations'
      path: '/calculations'
      fullPath: '/claim/$claimId/calculations'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimCalculationsRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimRoute
    }
    '/_claims/claim/$claimId/_claim/activity': {
      id: '/_claims/claim/$claimId/_claim/activity'
      path: '/activity'
      fullPath: '/claim/$claimId/activity'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimActivityRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimRoute
    }
    '/_risks/risk/$riskId/_risk/data/': {
      id: '/_risks/risk/$riskId/_risk/data/'
      path: '/data'
      fullPath: '/risk/$riskId/data/'
      preLoaderRoute: typeof RisksRiskRiskIdRiskDataIndexRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskRoute
    }
    '/_claims/claim/$claimId/_claim/data/': {
      id: '/_claims/claim/$claimId/_claim/data/'
      path: '/data'
      fullPath: '/claim/$claimId/data/'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimDataIndexRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimRoute
    }
    '/_claims/claim/$claimId/_claim/business/': {
      id: '/_claims/claim/$claimId/_claim/business/'
      path: '/business'
      fullPath: '/claim/$claimId/business/'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimBusinessIndexRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimRoute
    }
    '/_risks/risk/$riskId/_risk/calculations/summary': {
      id: '/_risks/risk/$riskId/_risk/calculations/summary'
      path: '/summary'
      fullPath: '/risk/$riskId/calculations/summary'
      preLoaderRoute: typeof RisksRiskRiskIdRiskCalculationsSummaryRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskCalculationsRoute
    }
    '/_risks/risk/$riskId/_risk/calculations/analysis': {
      id: '/_risks/risk/$riskId/_risk/calculations/analysis'
      path: '/analysis'
      fullPath: '/risk/$riskId/calculations/analysis'
      preLoaderRoute: typeof RisksRiskRiskIdRiskCalculationsAnalysisRouteImport
      parentRoute: typeof RisksRiskRiskIdRiskCalculationsRoute
    }
    '/_risks/risk/$riskId/(nopr)/edit/$page': {
      id: '/_risks/risk/$riskId/(nopr)/edit/$page'
      path: '/risk/$riskId/edit/$page'
      fullPath: '/risk/$riskId/edit/$page'
      preLoaderRoute: typeof RisksRiskRiskIdnoprEditPageRouteImport
      parentRoute: typeof RisksRoute
    }
    '/_risks/risk/$riskId/(nopr)/create/$page': {
      id: '/_risks/risk/$riskId/(nopr)/create/$page'
      path: '/risk/$riskId/create/$page'
      fullPath: '/risk/$riskId/create/$page'
      preLoaderRoute: typeof RisksRiskRiskIdnoprCreatePageRouteImport
      parentRoute: typeof RisksRoute
    }
    '/_claims/claim/$claimId/_claim/calculations/salesLoss': {
      id: '/_claims/claim/$claimId/_claim/calculations/salesLoss'
      path: '/salesLoss'
      fullPath: '/claim/$claimId/calculations/salesLoss'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimCalculationsSalesLossRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimCalculationsRoute
    }
    '/_claims/claim/$claimId/_claim/calculations/salesAnalysis': {
      id: '/_claims/claim/$claimId/_claim/calculations/salesAnalysis'
      path: '/salesAnalysis'
      fullPath: '/claim/$claimId/calculations/salesAnalysis'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimCalculationsRoute
    }
    '/_claims/claim/$claimId/_claim/calculations/loss': {
      id: '/_claims/claim/$claimId/_claim/calculations/loss'
      path: '/loss'
      fullPath: '/claim/$claimId/calculations/loss'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimCalculationsLossRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimCalculationsRoute
    }
    '/_claims/claim/$claimId/_claim/calculations/expenses': {
      id: '/_claims/claim/$claimId/_claim/calculations/expenses'
      path: '/expenses'
      fullPath: '/claim/$claimId/calculations/expenses'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimCalculationsExpensesRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimCalculationsRoute
    }
    '/_claims/claim/$claimId/_claim/calculations/collectible': {
      id: '/_claims/claim/$claimId/_claim/calculations/collectible'
      path: '/collectible'
      fullPath: '/claim/$claimId/calculations/collectible'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimCalculationsCollectibleRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimCalculationsRoute
    }
    '/_claims/claim/$claimId/_claim/calculations/average': {
      id: '/_claims/claim/$claimId/_claim/calculations/average'
      path: '/average'
      fullPath: '/claim/$claimId/calculations/average'
      preLoaderRoute: typeof ClaimsClaimClaimIdClaimCalculationsAverageRouteImport
      parentRoute: typeof ClaimsClaimClaimIdClaimCalculationsRoute
    }
    '/_claims/claim/$claimId/(questionnaire)/business/$page': {
      id: '/_claims/claim/$claimId/(questionnaire)/business/$page'
      path: '/claim/$claimId/business/$page'
      fullPath: '/claim/$claimId/business/$page'
      preLoaderRoute: typeof ClaimsClaimClaimIdquestionnaireBusinessPageRouteImport
      parentRoute: typeof ClaimsRoute
    }
    '/_claims/claim/$claimId/(fnol)/edit/$page': {
      id: '/_claims/claim/$claimId/(fnol)/edit/$page'
      path: '/claim/$claimId/edit/$page'
      fullPath: '/claim/$claimId/edit/$page'
      preLoaderRoute: typeof ClaimsClaimClaimIdfnolEditPageRouteImport
      parentRoute: typeof ClaimsRoute
    }
    '/_claims/claim/$claimId/(fnol)/create/$page': {
      id: '/_claims/claim/$claimId/(fnol)/create/$page'
      path: '/claim/$claimId/create/$page'
      fullPath: '/claim/$claimId/create/$page'
      preLoaderRoute: typeof ClaimsClaimClaimIdfnolCreatePageRouteImport
      parentRoute: typeof ClaimsRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAdminUserRoute: typeof AdminAdminUserRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminUserRoute: AdminAdminUserRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ClaimsClaimClaimIdClaimCalculationsRouteChildren {
  ClaimsClaimClaimIdClaimCalculationsAverageRoute: typeof ClaimsClaimClaimIdClaimCalculationsAverageRoute
  ClaimsClaimClaimIdClaimCalculationsCollectibleRoute: typeof ClaimsClaimClaimIdClaimCalculationsCollectibleRoute
  ClaimsClaimClaimIdClaimCalculationsExpensesRoute: typeof ClaimsClaimClaimIdClaimCalculationsExpensesRoute
  ClaimsClaimClaimIdClaimCalculationsLossRoute: typeof ClaimsClaimClaimIdClaimCalculationsLossRoute
  ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute: typeof ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute
  ClaimsClaimClaimIdClaimCalculationsSalesLossRoute: typeof ClaimsClaimClaimIdClaimCalculationsSalesLossRoute
}

const ClaimsClaimClaimIdClaimCalculationsRouteChildren: ClaimsClaimClaimIdClaimCalculationsRouteChildren =
  {
    ClaimsClaimClaimIdClaimCalculationsAverageRoute:
      ClaimsClaimClaimIdClaimCalculationsAverageRoute,
    ClaimsClaimClaimIdClaimCalculationsCollectibleRoute:
      ClaimsClaimClaimIdClaimCalculationsCollectibleRoute,
    ClaimsClaimClaimIdClaimCalculationsExpensesRoute:
      ClaimsClaimClaimIdClaimCalculationsExpensesRoute,
    ClaimsClaimClaimIdClaimCalculationsLossRoute:
      ClaimsClaimClaimIdClaimCalculationsLossRoute,
    ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute:
      ClaimsClaimClaimIdClaimCalculationsSalesAnalysisRoute,
    ClaimsClaimClaimIdClaimCalculationsSalesLossRoute:
      ClaimsClaimClaimIdClaimCalculationsSalesLossRoute,
  }

const ClaimsClaimClaimIdClaimCalculationsRouteWithChildren =
  ClaimsClaimClaimIdClaimCalculationsRoute._addFileChildren(
    ClaimsClaimClaimIdClaimCalculationsRouteChildren,
  )

interface ClaimsClaimClaimIdClaimRouteChildren {
  ClaimsClaimClaimIdClaimActivityRoute: typeof ClaimsClaimClaimIdClaimActivityRoute
  ClaimsClaimClaimIdClaimCalculationsRoute: typeof ClaimsClaimClaimIdClaimCalculationsRouteWithChildren
  ClaimsClaimClaimIdClaimDocumentsRoute: typeof ClaimsClaimClaimIdClaimDocumentsRoute
  ClaimsClaimClaimIdClaimReportRoute: typeof ClaimsClaimClaimIdClaimReportRoute
  ClaimsClaimClaimIdClaimIndexRoute: typeof ClaimsClaimClaimIdClaimIndexRoute
  ClaimsClaimClaimIdClaimBusinessIndexRoute: typeof ClaimsClaimClaimIdClaimBusinessIndexRoute
  ClaimsClaimClaimIdClaimDataIndexRoute: typeof ClaimsClaimClaimIdClaimDataIndexRoute
}

const ClaimsClaimClaimIdClaimRouteChildren: ClaimsClaimClaimIdClaimRouteChildren =
  {
    ClaimsClaimClaimIdClaimActivityRoute: ClaimsClaimClaimIdClaimActivityRoute,
    ClaimsClaimClaimIdClaimCalculationsRoute:
      ClaimsClaimClaimIdClaimCalculationsRouteWithChildren,
    ClaimsClaimClaimIdClaimDocumentsRoute:
      ClaimsClaimClaimIdClaimDocumentsRoute,
    ClaimsClaimClaimIdClaimReportRoute: ClaimsClaimClaimIdClaimReportRoute,
    ClaimsClaimClaimIdClaimIndexRoute: ClaimsClaimClaimIdClaimIndexRoute,
    ClaimsClaimClaimIdClaimBusinessIndexRoute:
      ClaimsClaimClaimIdClaimBusinessIndexRoute,
    ClaimsClaimClaimIdClaimDataIndexRoute:
      ClaimsClaimClaimIdClaimDataIndexRoute,
  }

const ClaimsClaimClaimIdClaimRouteWithChildren =
  ClaimsClaimClaimIdClaimRoute._addFileChildren(
    ClaimsClaimClaimIdClaimRouteChildren,
  )

interface ClaimsRouteChildren {
  ClaimsClaimsIndexRoute: typeof ClaimsClaimsIndexRoute
  ClaimsClaimClaimIdClaimRoute: typeof ClaimsClaimClaimIdClaimRouteWithChildren
  ClaimsClaimClaimIdfnolCreatePageRoute: typeof ClaimsClaimClaimIdfnolCreatePageRoute
  ClaimsClaimClaimIdfnolEditPageRoute: typeof ClaimsClaimClaimIdfnolEditPageRoute
  ClaimsClaimClaimIdquestionnaireBusinessPageRoute: typeof ClaimsClaimClaimIdquestionnaireBusinessPageRoute
}

const ClaimsRouteChildren: ClaimsRouteChildren = {
  ClaimsClaimsIndexRoute: ClaimsClaimsIndexRoute,
  ClaimsClaimClaimIdClaimRoute: ClaimsClaimClaimIdClaimRouteWithChildren,
  ClaimsClaimClaimIdfnolCreatePageRoute: ClaimsClaimClaimIdfnolCreatePageRoute,
  ClaimsClaimClaimIdfnolEditPageRoute: ClaimsClaimClaimIdfnolEditPageRoute,
  ClaimsClaimClaimIdquestionnaireBusinessPageRoute:
    ClaimsClaimClaimIdquestionnaireBusinessPageRoute,
}

const ClaimsRouteWithChildren =
  ClaimsRoute._addFileChildren(ClaimsRouteChildren)

interface RisksRiskRiskIdRiskCalculationsRouteChildren {
  RisksRiskRiskIdRiskCalculationsAnalysisRoute: typeof RisksRiskRiskIdRiskCalculationsAnalysisRoute
  RisksRiskRiskIdRiskCalculationsSummaryRoute: typeof RisksRiskRiskIdRiskCalculationsSummaryRoute
}

const RisksRiskRiskIdRiskCalculationsRouteChildren: RisksRiskRiskIdRiskCalculationsRouteChildren =
  {
    RisksRiskRiskIdRiskCalculationsAnalysisRoute:
      RisksRiskRiskIdRiskCalculationsAnalysisRoute,
    RisksRiskRiskIdRiskCalculationsSummaryRoute:
      RisksRiskRiskIdRiskCalculationsSummaryRoute,
  }

const RisksRiskRiskIdRiskCalculationsRouteWithChildren =
  RisksRiskRiskIdRiskCalculationsRoute._addFileChildren(
    RisksRiskRiskIdRiskCalculationsRouteChildren,
  )

interface RisksRiskRiskIdRiskRouteChildren {
  RisksRiskRiskIdRiskActivityRoute: typeof RisksRiskRiskIdRiskActivityRoute
  RisksRiskRiskIdRiskCalculationsRoute: typeof RisksRiskRiskIdRiskCalculationsRouteWithChildren
  RisksRiskRiskIdRiskDocumentsRoute: typeof RisksRiskRiskIdRiskDocumentsRoute
  RisksRiskRiskIdRiskReportRoute: typeof RisksRiskRiskIdRiskReportRoute
  RisksRiskRiskIdRiskIndexRoute: typeof RisksRiskRiskIdRiskIndexRoute
  RisksRiskRiskIdRiskDataIndexRoute: typeof RisksRiskRiskIdRiskDataIndexRoute
}

const RisksRiskRiskIdRiskRouteChildren: RisksRiskRiskIdRiskRouteChildren = {
  RisksRiskRiskIdRiskActivityRoute: RisksRiskRiskIdRiskActivityRoute,
  RisksRiskRiskIdRiskCalculationsRoute:
    RisksRiskRiskIdRiskCalculationsRouteWithChildren,
  RisksRiskRiskIdRiskDocumentsRoute: RisksRiskRiskIdRiskDocumentsRoute,
  RisksRiskRiskIdRiskReportRoute: RisksRiskRiskIdRiskReportRoute,
  RisksRiskRiskIdRiskIndexRoute: RisksRiskRiskIdRiskIndexRoute,
  RisksRiskRiskIdRiskDataIndexRoute: RisksRiskRiskIdRiskDataIndexRoute,
}

const RisksRiskRiskIdRiskRouteWithChildren =
  RisksRiskRiskIdRiskRoute._addFileChildren(RisksRiskRiskIdRiskRouteChildren)

interface RisksRouteChildren {
  RisksRisksIndexRoute: typeof RisksRisksIndexRoute
  RisksRiskRiskIdRiskRoute: typeof RisksRiskRiskIdRiskRouteWithChildren
  RisksRiskRiskIdnoprCreatePageRoute: typeof RisksRiskRiskIdnoprCreatePageRoute
  RisksRiskRiskIdnoprEditPageRoute: typeof RisksRiskRiskIdnoprEditPageRoute
}

const RisksRouteChildren: RisksRouteChildren = {
  RisksRisksIndexRoute: RisksRisksIndexRoute,
  RisksRiskRiskIdRiskRoute: RisksRiskRiskIdRiskRouteWithChildren,
  RisksRiskRiskIdnoprCreatePageRoute: RisksRiskRiskIdnoprCreatePageRoute,
  RisksRiskRiskIdnoprEditPageRoute: RisksRiskRiskIdnoprEditPageRoute,
}

const RisksRouteWithChildren = RisksRoute._addFileChildren(RisksRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ClaimsRoute: ClaimsRouteWithChildren,
  RisksRoute: RisksRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
